// extracted by mini-css-extract-plugin
export default {"basicBody":"basicServices_basicBody__JlHTM","basicItem":"basicServices_basicItem__XFfT0"};